module.exports = __webpack_public_path__ + "media/images/favorite-default-tab-8e6e4b85b8d2839736e2d12090c3f2e3.svg";